import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function ProductPresentation() {
  return <section className="py-20 bg-[#0C2818] overflow-hidden" data-id="element-266">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-267">
        <div className="flex flex-col lg:flex-row items-center gap-12" data-id="element-268">
          {/* Content */}
          <div className="flex-1 lg:pr-8" data-id="element-269">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} data-id="element-270">
              <span className="inline-block py-1 px-3 rounded-full bg-[#FBBF24] text-[#0C2818] font-bold text-sm mb-6 uppercase tracking-wider" data-id="element-271">
                MEGAPACK LISTO PARA IMPRIMIR
              </span>

              <h2 className="text-4xl md:text-5xl font-black text-white mb-6 leading-tight" data-id="element-272">
                MEGAPACK EDUCACIÓN FÍSICA LISTA
              </h2>

              <p className="text-xl text-gray-300 mb-8 leading-relaxed" data-id="element-273">
                Un sistema completo de planificación y actividades para
                educación física que te permite tener todo el año organizado
                desde hoy.
              </p>

              <div className="space-y-4 mb-10" data-id="element-274">
                {['Actividades organizadas por nivel y edad.', 'Clases estructuradas paso a paso.', 'Material listo para aplicar inmediatamente en el patio o gimnasio.'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-275">
                    <Check className="w-6 h-6 text-[#16A34A] flex-shrink-0 mt-0.5" data-id="element-276" />
                    <span className="text-lg text-white font-medium" data-id="element-277">
                      {item}
                    </span>
                  </div>)}
              </div>

              <div className="flex flex-wrap gap-3" data-id="element-278">
                {['Con planificación anual', 'Con actividades listas', 'Con evaluaciones físicas', 'Con guiones de clase'].map((badge, i) => <span key={i} className="bg-[#FBBF24]/10 text-[#FBBF24] border border-[#FBBF24]/30 px-4 py-2 rounded-lg text-sm font-bold" data-id="element-279">
                    {badge}
                  </span>)}
              </div>
            </motion.div>
          </div>

          {/* Image */}
          <motion.div initial={{
          opacity: 0,
          x: 50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="flex-1 w-full max-w-lg mx-auto lg:max-w-none relative" data-id="element-280">
            <div className="absolute -inset-4 bg-gradient-to-r from-[#16A34A] to-[#FBBF24] rounded-xl blur-2xl opacity-20" data-id="element-281"></div>
            <img src="https://cdn.magicpatterns.com/uploads/1YUtJDJVs1ZKhrEJoXRy3i/1_COVER.png" alt="MegaPack Educación Física LISTA" loading="lazy" width={460} height={600} className="relative w-full rounded-2xl shadow-2xl border border-[#1E4D2B]" data-id="element-282" />
          </motion.div>
        </div>
      </div>
    </section>;
}